import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Color, CommonProperties } from '../styles';
import BaseText from './BaseText';
import Icon from './Icon';

const FormLabel = ({ errorMessage }) => {
  return (
    <View style={styles.errorContainer}>
      <Icon name="error" size={11} color={Color.required} />
      <BaseText style={styles.errorLabel}>{errorMessage}</BaseText>
    </View>
  );
};

const styles = StyleSheet.create({
  errorContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  errorLabel: {
    color: Color.required,
    ...CommonProperties.small,
    ...CommonProperties.ml2,
  },
});

export default FormLabel;
